module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes,
    attrs: {
      "disabled": _vm.disableStatus
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentVal),
      expression: "currentVal"
    }],
    staticClass: "input input-number__input",
    attrs: {
      "disabled": _vm.disableStatus,
      "type": "text"
    },
    domProps: {
      "value": (_vm.currentVal)
    },
    on: {
      "focus": _vm._focus,
      "blur": _vm._blur,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentVal = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "input-number__control input-number--decrease",
    class: [_vm.disabled_minus ? 'btn-secondary' : ''],
    attrs: {
      "disabled": _vm.disabled_minus,
      "type": "button"
    },
    on: {
      "click": _vm._minus
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "input-number__control input-number--increase",
    class: [_vm.disabled_plus ? 'btn-secondary' : ''],
    attrs: {
      "disabled": _vm.disabled_plus,
      "type": "button"
    },
    on: {
      "click": _vm._plus
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65eb0723"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/numberstepper.vue
// module id = 377
// module chunks = 0